import PropTypes from 'prop-types'
import {
  blogPostDescriptionPlaceholder,
  blogPostImageUrlPlaceholder,
  blogPostTitlePlaceholder,
} from 'publisher/reducers/blogReducer'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import useBlog from '../../hooks/useBlog'
import useManagement from '../../hooks/useManagement'
import usePage from '../../hooks/usePage'
import {
  getBlogPostDescrition,
  getBlogPostImageUrl,
  getBlogPostTitle,
} from '../../reducers/blogReducer'
import { getFile } from '../../reducers/filesReducer'
import { getUrl } from '../../reducers/managementReducer'
import { getSeo } from '../../reducers/pageReducer'
import { getSeoSocialImageFileId } from '../../store/page/pageSelectors'

function Meta({ noIndex = false }) {
  const seo = usePage(getSeo)
  const socialImageFileId = usePage(getSeoSocialImageFileId)
  const file = useSelector(state => getFile(state.files, socialImageFileId))
  const blogPostImageUrl = useBlog(getBlogPostImageUrl)
  const blogPostTitle = useBlog(getBlogPostTitle)
  const blogPostDescription = useBlog(getBlogPostDescrition)
  const currentDescription = seo.description || blogPostDescription
  const currentTitle = seo.title || blogPostTitle
  const currentImagePath = file?.path || blogPostImageUrl || ''

  const ogImagePath =
    currentImagePath !== blogPostImageUrlPlaceholder ? currentImagePath : ''
  const ogTitle = currentTitle !== blogPostTitlePlaceholder ? currentTitle : ''
  const ogDescrition =
    currentDescription !== blogPostDescriptionPlaceholder
      ? currentDescription
      : ''
  const url = useManagement(getUrl)

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="title" content={seo.title} />
      <meta name="description" content={seo.description} />
      <meta name="author" content={seo.author} />
      <meta name="keywords" content={seo.keywords} />
      <meta property="og:image" content={ogImagePath} />
      {ogImagePath && <meta property="og:image:alt" content={seo.title} />}
      {ogTitle && <meta property="og:title" content={ogTitle} />}
      {ogDescrition && (
        <meta property="og:description" content={ogDescrition} />
      )}
      <meta property="og:url" content={url} />
      {noIndex && <meta name="robots" content="noindex" />}
    </Helmet>
  )
}

Meta.propTypes = {
  noIndex: PropTypes.bool,
}

export default Meta
